var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('GroupHeader'),_c('GroupDocuments')],1),_c('v-col',{attrs:{"cols":"12","lg":"3"}},[_c('GroupSideBar')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }